import { render, staticRenderFns } from "./recommendList.vue?vue&type=template&id=58809cd5&scoped=true"
import script from "./recommendList.vue?vue&type=script&lang=js"
export * from "./recommendList.vue?vue&type=script&lang=js"
import style0 from "./recommendList.vue?vue&type=style&index=0&id=58809cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58809cd5",
  null
  
)

export default component.exports